import { TextField } from "../../utils/form";

const Legend = ({ form: { control } }) => (
  <TextField
    control={control}
    name="legend"
    placeholder="Como se mostrará bajo su nombre"
    variant="outlined"
    required
    fullWidth
    sx={{ backgroundColor: "#F2F9FF66" }}
  />
);

export default Legend;
